import { connect } from 'react-redux';

import { currentAppDefinitionEntity } from 'app/developer-v3/selectors';

import IssuesPage from './IssuesPage';

const mapStateToProps = state => {
  const appDefinitionEntity = currentAppDefinitionEntity(state);

  // Triggers and actions are stored in different places for CLI apps and UI apps
  // UI apps -> data.definition_override
  // CLI apps -> data.definition
  //
  // TODO: This is fetching triggers and actions of the opened version in the
  // UI. We should relaly fetch the version in public. It'll be consistent with
  // Loki.
  const definition =
    appDefinitionEntity.data[
      appDefinitionEntity.data.is_ui ? 'definition_override' : 'definition'
    ];
  const triggers = definition?.triggers || {};
  const actions = {
    ...(definition?.creates || {}),
    ...(definition?.searches || {}),
  };

  return { actions, triggers };
};

export default connect(mapStateToProps)(IssuesPage);
